import { DictionaryScheduleType, ExtractScheduleType, LoadingStatusEnum, DictionaryScheduleTypeSchema, ExtractScheduleTypeSchema, } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type LoadScheduleTypesRequest = {
	forceReload?: boolean
} | void;

type LoadScheduleTypesResponse = {
	extractScheduleTypes: ExtractScheduleType[];
	dictionaryScheduleTypes: DictionaryScheduleType[];
};

export const loadScheduleTypes = createAppAsyncThunk<LoadScheduleTypesResponse, LoadScheduleTypesRequest>(
	"etlData/loadScheduleTypes",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {
		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			const [dictionaryScheduleTypes, extractScheduleTypes] = await Promise.all([
				extra.etlClient.findAll(DictionaryScheduleTypeSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(ExtractScheduleTypeSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
			]);

			return {
				extractScheduleTypes,
				dictionaryScheduleTypes,
			}
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (data, { getState }) => {
			if (data?.forceReload) return true;
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.scheduleTypesLoadingStatus);
		}
	}
);
